import { FormCard } from '@portal_components/components/FormCard';
import { Group } from '../../types';
import { FormTextInput } from '@portal_components/components/FormTextInput';

interface CustomerContactsTabProps {
  readonly: boolean;
}

export const CustomerContactsTab = ({ readonly }: CustomerContactsTabProps) => {
  return (
    <FormCard>
      <div className="grid grid-cols-3 gap-2 w-full">
        <FormTextInput<Group> title="Contact Name" name={`contact.groupContactName`} readonly={readonly} mandatory hideErrorControl />
        <FormTextInput<Group> title="Contact Email Address" name={`contact.emailAddress`} readonly={readonly} hideErrorControl />
        <FormTextInput<Group> title="Contact Job Title" name={`contact.jobTitle`} readonly={readonly} hideErrorControl />
        <FormTextInput<Group> title="Contact Phone Number" name={`contact.groupContactNumber`} readonly={readonly} hideErrorControl />
        <FormTextInput<Group> title="Contact Extension" name={`contact.extensionNumber`} readonly={readonly} hideErrorControl />
      </div>
    </FormCard>
  );
};
